<div class="chat-backdrop" [class.show]="isOpen()" (click)="sendbirdChatService.hideChat()"></div>
<div class="chat-container" [class.visible]="isVisible()" [class.active]="isActive()" #chatContainer>
  <app-chat-header></app-chat-header>
  <div class="content" [appLoading]="isLoading()" #contentWrapper>
    <div class="message-item-wrap" #contentRef>
      <ng-container *ngFor="let msg of rawMessages(); let i = index">
        <ng-container *ngTemplateOutlet="messageItem; context: { item: msg, index: i }"></ng-container>
      </ng-container>
    </div>
    <div class="group">
      <div *ngIf="showScrollBottom" class="item scroll-to-bottom" (click)="scrollToBottom()">
        <i class="fi-pause"></i>
        <span>Resume chat</span>
      </div>
      <div *ngIf="restrictionType()" class="item timeout-notify">
        <div class="timeout-title" [ngClass]="restrictionType()">
          <ng-container [ngSwitch]="restrictionType()">
            <ng-container *ngSwitchCase="'ban'">
              <i class="fi-x-circle"></i>
              <span>You've been banned by a moderator</span>
            </ng-container>
            <ng-container *ngSwitchCase="'deactivate'">
              <i class="fi-ban-filled"></i>
              <span>You've been deactivated by a moderator</span>
            </ng-container>
            <ng-container *ngSwitchCase="'idle'">
              <i class="fi-ban-filled"></i>
              <span>You were kicked from the chat room due to inactivity</span>
            </ng-container>
            <ng-container *ngSwitchCase="'full'">
              <i class="fi-ban-filled"></i>
              <span>The chat room is currently full, please come back later</span>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <i class="fi-x-circle"></i>
              <span>You've been timed out by a moderator</span>
            </ng-container>
          </ng-container>
        </div>
        <div class="countdown">
          <ng-container
            *ngIf="
              restrictionType() === 'deactivate' ||
              restrictionType() === 'idle' ||
              restrictionType() === 'full' ||
              (restrictionType() === 'ban' && isContactSupport())
            "
          >
            <span [ngClass]="restrictionType()">Please refresh the page and try joining the room again</span>
          </ng-container>
          <ng-container *ngIf="(restrictionType() === 'mute' || restrictionType() === 'ban') && !!remainingSeconds()">
            <span>{{ remainingSeconds() }}</span>
            <span>remaining</span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <!-- 回覆訊息 -->
    <app-reply-preview
      *ngIf="replyMessage()"
      [parentMessage]="replyMessage()"
      (cancelReplyPreview)="handleCancelReplayMessage()"
    >
    </app-reply-preview>
    <div class="input-msg">
      <app-chat-input
        class="input"
        [disabled]="!!restrictionType() || isLoading() || isSending()"
        [ngModel]="newMessage()"
        (ngModelChange)="handleInputChange($event)"
        (sendMessage)="handleSendMessage()"
      ></app-chat-input>
      <cs-button
        class="send-btn"
        [disabled]="!!restrictionType() || !newMessage() || isSending()"
        [label]="replyMessage() ? 'Reply' : 'Send'"
        [color]="'primary'"
        [size]="'default'"
        [width]="'80px'"
        (click)="handleSendMessage()"
      />
    </div>
  </div>
</div>

<ng-template #messageItem let-item="item" let-index="index">
  <div class="item-wrap">
    <app-chat-avatar [sender]="item.message.sender"></app-chat-avatar>
    <div class="message-container" (transitionend)="handleBlinkAnimEnd(index)">
      <div class="left">
        <!-- sendbird reply thread -->
        <div
          class="reply-message"
          *ngIf="item.message.parentMessage"
          (click)="handleClickReplyMessage(item.message.parentMessage)"
        >
          <span class="nickname">{{ item.message.parentMessage.sender.nickname || 'Unknown' }}</span>
          <span>: </span>
          <span class="text">{{ item.message.parentMessage.message || '' }}</span>
        </div>
        <!-- 自定義回覆訊息 -->
        <!-- <div class="reply-message" *ngIf="item.message?.data?.type === 'reply'">
          <span class="nickname">{{ item.message.data?.content?.sender.nickname || 'Unknown' }}</span>
          <span>: </span>
          <span class="text">{{ item.message.data?.content.message || '' }}</span>
        </div> -->
        <div class="text-wrap">
          <span class="nickname" (click)="handleClickUsername(item.message.sender)">{{
            item.message.sender?.nickname || 'Unknown'
          }}</span>
          <span>: </span>
          <span class="text">
            <ng-container *ngFor="let part of item.template">
              @if (part?.type === 'mention') {
                <span class="nickname" (click)="handleClickUsername(part.user)">{{ '@' + part.user.nickname }}</span>
              } @else {
                <span [innerHTML]="part"></span>
              }
            </ng-container>
          </span>
        </div>
        <div class="chat-icon-list">
          <!-- 因為reply thread 只能回一次，所以需要隱藏回覆按鈕 -->
          <i *ngIf="!item.message.parentMessage" class="fi-reply-filled" (click)="handleReplyMessage(item.message)"></i>
          <!-- <i class="fi-rss"></i>
          <i class="fi-trash"></i>
          <i class="fi-clock"></i>
          <i class="fi-ban"></i> -->
        </div>
      </div>
      <!-- 按讚 component -->
      <app-reaction-button [message]="item.message" [currentUserId]="userId"></app-reaction-button>
    </div>
  </div>
</ng-template>
